import React from 'react'
import "./Section4.scss"
function Section4() {
    return (
        <div className="ourmoto">
            <h1 className="heading">Our Motto</h1>
            <p>
            We at Techgeeksfirm aim to provide the best technical solution for your Problem or an Idea that needs to be molded into a web application or a mobile application. We belive in quality work instead of quantity and always keep our clients on first priority, client-developer engagement is the thing that matters to us the most. Come start a project with us and be a part of our family and help us grow big and prosper
            </p>
        </div>
    )
}

export default Section4
